import { isGa4EcommerceData } from './utils';
import { createCustomDimensionsRepository } from '../customDimensionsRepository';
import {
  ECommerce4Item,
  ECommerce4Transaction,
  ProductHandler,
  ProductHandlers,
  TrackECommerceArg,
} from './types';
import { createConfigParametersRepository } from '../../configParametersRepository';
import { parseCookieDomain } from '../utils/cookie';
import { ECommerceItem } from '../types';

export const handleProducts = async (
  eCommerceData: TrackECommerceArg | ECommerce4Transaction
) => {
  const productHandler = createProductHandler();
  //TODO: remove this when ga4 is fully implemented
  const products = isGa4EcommerceData(eCommerceData)
    ? eCommerceData.items
    : eCommerceData.products;

  if (products) {
    for (const product of products) {
      await productHandler.handleProduct(product);
    }
  }
};

const createProductHandler = () => {
  const customDimensionsRepository = createCustomDimensionsRepository();
  /**
   * An object that maps product names to their respective handlers.
   */
  const productHandlers: ProductHandlers = {
    SUBSCRIPTION: {
      handleProduct: async () => {
        const { getTrackingStorageClient } = createConfigParametersRepository();
        const storageClient = getTrackingStorageClient();
        storageClient.setCookie(
          'ua_dimension31',
          'subscriber',
          30,
          parseCookieDomain()
        );
        customDimensionsRepository.set({
          customDimension: '31',
          value: 'subscriber',
        });
      },
    },
  };

  return {
    /**
     * Handles the given product based on its name using the corresponding function
     * defined in "productHandlers".
     *
     * @param {ECommerceItem} product - The product object to handle.
     */
    handleProduct: async (product: ECommerceItem | ECommerce4Item) => {
      let productHandler: ProductHandler;
      //UA FORMAT
      if ('name' in product) {
        productHandler = productHandlers[product.name];
      }
      //GA4 FORMAT
      if ('item_name' in product) {
        productHandler = productHandlers[product.item_name];
      }
      if (!productHandler) {
        return;
      }
      await productHandler.handleProduct();
    },
  };
};
